import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleAutoCompleteComponent } from './google-auto-complete/google-auto-complete.component';
import { GoogleDirectionComponent } from './google-direction/google-direction.component';
import { AgmCoreModule } from '@agm/core';
import { GoogleDropdownComponent } from './google-dropdown/google-dropdown.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeocodeAutoCompleteComponent } from './geocode-auto-complete/geocode-auto-complete.component';
import { SharedModule } from 'src/app/shared/shared.module';
@NgModule({
  imports: [
    CommonModule,
    AgmCoreModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyBJ53kSB8cD7BqSNpsnPztwhHnQP-UKdxY',
    //   libraries: ['places']
    // }),
  ],
  declarations: [GoogleAutoCompleteComponent, GoogleDirectionComponent, GoogleDropdownComponent, GeocodeAutoCompleteComponent],
  exports: [GoogleAutoCompleteComponent, GoogleDirectionComponent, GoogleDropdownComponent]
})
export class GoogleModule { }
